// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import {
  Modal,
  Button
} from '../'
import { CancelForm } from './CancelForm'


export class CancelModal extends React.PureComponent {
  static propTypes = {
    title: PropTypes.string,
    onCancelClick: PropTypes.func.isRequired,
    onConfirmClick: PropTypes.func.isRequired
  }

  static defaultProps = {
    title: 'Cancel withdrawal'
  }

  state = {
    cancelledBy: null
  }

  handleCancelledByChange = (e) => (
    this.setState({ cancelledBy: e.target.value })
  )

  render() {
    const { title, onCancelClick, onConfirmClick } = this.props

    return (
      <Modal
        heading={title}
        body={
          <CancelForm
            cancelledBy={this.state.cancelledBy}
            onSelect={this.handleCancelledByChange}
          />
        }
        footer={
          <div className='slds-text-align_center'>
            <Button minWidth={120} onClick={onCancelClick}>
              Cancel
            </Button>
            <Button
              type='brand'
              minWidth={120}
              disabled={!this.state.cancelledBy}
              onClick={() => onConfirmClick(this.state.cancelledBy)}>
              Confirm
            </Button>
          </div>
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/withdrawal-detail/CancelModal.js